/* eslint-disable react/react-in-jsx-scope */
import React, { useContext, useMemo } from "react";
import { Context } from "../Store";
import styles from "./Timeline.module.scss";
import { capitalize, createPlayerMap, parseCompletedGames } from "../utils/helpers";
import ActionReplays from "./ActionReplays";
import { openLightbox, handleHover } from "../utils/storyUIHandlers";

const Timeline = () => {
  const [state] = useContext(Context);

  const playerMap = useMemo(() => createPlayerMap(state?.players), [state.players]);

  const games = useMemo(() => parseCompletedGames(state?.newsfeed, true), [state.newsfeed]);

  const formatAllPlayers = (players = []) =>
    players.map((entry, index) => {
      // Get the player names
      const teamNames = Array.isArray(entry)
        ? entry.map((id) => playerMap[id] || id).join(" & ")
        : playerMap[entry] || entry;

      // Wrap in a span
      return <span key={index}>{capitalize(teamNames)}</span>;
    });

  const formatPlacement = (placement = []) => capitalize(placement.map((id) => playerMap[id] || id).join(" & ") || "—");

  const showOche = useMemo(() => {
    return new Set(games.map((g) => g.oche)).size > 1;
  }, [games]);

  return (
    <div className="section section--padded">
      <div className={styles.timelineSection}>
        <h2>Game Timeline</h2>
        {games.map((game, index) => (
          <div key={`${game.startTime}-${game.oche}`} className={styles.game}>
            <div className={styles.title}>
              <span className={styles.red}>Game {index + 1}: </span>
              {game.name}
              {showOche && ` (Oche ${game.oche})`}
            </div>

            <div className={styles.teamResults}>
              <div>
                <span className={styles.innerTitle}>Teams</span>
                <div className={styles.playerTeams}>{formatAllPlayers(game.players)}</div>
              </div>

              <div>
                <span className={styles.innerTitle}>Results</span>
                <div className={styles.placement}>
                  <span className={styles.title}>Winner: </span>
                  {formatPlacement(game.first)}
                </div>
                <div className={styles.placement}>
                  <span className={styles.title}>2nd: </span>
                  {formatPlacement(game.second)}
                </div>

                {game.players.length > 2 && (
                  <div className={styles.placement}>
                    <span className={styles.title}>3rd: </span>
                    {formatPlacement(game.third)}
                  </div>
                )}
              </div>
            </div>

            {game.replays.length > 0 && (
              <div className={styles.replays}>
                <div className={styles.innerTitle}>Action replays</div>
                <ActionReplays
                  key={`${game.startTime}-${game.oche}-replays`}
                  videos={game.replays}
                  handleHover={handleHover}
                  openLightbox={openLightbox}
                  section="timeline"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
